module.exports = __webpack_public_path__ + "static/media/expense.49c6e61c.svg";